// extracted by mini-css-extract-plugin
module.exports = {"container":"TextInput_container__2ho_x","text_input":"TextInput_text_input__2mHnU","disabled":"TextInput_disabled__mPaMJ","prefix":"TextInput_prefix__2fsrA"};